import { motion } from 'framer-motion';
import React, { FC } from 'react';

interface Props {
  prompts: string[];
  onClick: (text: string) => void;
}

const ROWS = 3;

const Suggestions: FC<Props> = ({ prompts, onClick }) => {
  const rows = Array.from({ length: ROWS }, (_, rowIndex) =>
    prompts.filter((_, i) => i % ROWS === rowIndex),
  );

  return (
    <div className='relative md:hidden space-y-2 overflow-hidden max-h-[140px]'>
      {rows.map((row, rowIndex) => {
        // Duplicate the row to allow seamless looping
        const repeatedRow = [...row, ...row];
        return (
          <motion.div
            key={rowIndex}
            className='flex gap-2 w-max'
            animate={{
              x:
                rowIndex === 1
                  ? ['0%', '50%'] // middle row: start at right (0) → move right
                  : rowIndex % 2 === 0
                    ? ['0%', '-50%'] // top & bottom: left
                    : ['-50%', '0%'],
            }}
            transition={{
              duration: 28,
              ease: 'linear',
              repeat: Infinity,
            }}
          >
            {repeatedRow.map((text, i) => (
              <button
                key={`${text}-${rowIndex}-${i}`}
                onClick={() => onClick(text)}
                className='px-3 py-[7px] text-sm leading-[22px] rounded-lg border border-grayZl-800 whitespace-nowrap hover:bg-[#2A2A2B]'
              >
                {text}
              </button>
            ))}
          </motion.div>
        );
      })}
    </div>
  );
};

export default Suggestions;
